import React, { memo } from 'react';
import { string } from 'prop-types';

import PictureIcon from 'media/icons/picture.icon.svg';

const ImagePlaceholder = ({ className }) => (
  <div className={className}>
    <PictureIcon />
  </div>
);

ImagePlaceholder.propTypes = {
  className: string,
};

ImagePlaceholder.defaultProps = {
  className: '',
};

export default memo(ImagePlaceholder);



// WEBPACK FOOTER //
// ./src/components/ImagePlaceholder/ImagePlaceholder.js